module.exports = __webpack_public_path__ + "img/1529507840.67cfff79.jpg";